"use client";

import Image from "next/image";
import { useEffect, useState } from "react";

/**
 * The item's picture at the app's 72px thumbnail size. Nothing in its place
 * when there is none or it fails to load: the text column takes the width.
 */
export default function RadarEntryImage({ src }: { src?: string }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [src]);
  if (!src || failed) return null;
  return (
    <Image
      src={src}
      alt=""
      width={72}
      height={72}
      unoptimized
      onError={() => setFailed(true)}
      className="h-[72px] w-[72px] shrink-0 rounded-lg object-cover"
    />
  );
}
